"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = Radio;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _Media = require("../../Media");

var _Radio = require("./Radio.styled");

var __jsx = _react["default"].createElement;

function Radio(_ref) {
  var label = _ref.label,
      description = _ref.description,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["label", "description"]);
  var hasDescription = description.length > 0;
  return __jsx(_Radio.Radio, {
    as: "label",
    hasDescription: hasDescription
  }, __jsx(_Media.MediaObject, null, __jsx(_formik.Field, (0, _extends2["default"])({
    type: "radio"
  }, props)), __jsx(_Radio.RadioState, null)), __jsx(_Media.MediaBody, null, __jsx(_Radio.Label, null, label), description && __jsx(_Radio.Description, null, description)));
}

Radio.defaultProps = {
  description: ''
};
var _default = Radio;
exports["default"] = _default;